import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withNamespaces, Trans } from 'react-i18next';

class RedirectFirstmile extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <div className="main-container d-flex flex-column align-items-center">
        <div>
          <nav aria-label="breadcrumb" >
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><LinkContainer to="/scan"><a><Trans>Home</Trans></a></LinkContainer></li>
              <li className="breadcrumb-item active" aria-current="page"><Trans>Firstmile</Trans></li>
            </ol>
          </nav>
          <div className="content-container card mt-1 mb-5 p-2">
            <LinkContainer to="/scan/firstmile/pickup">
              <button
                type="button"
                className="text-white btn btn-lg btn-janio btn-janio-redirect mb-2">
                <Trans>Pick Up</Trans>
                </button>
            </LinkContainer>
            <LinkContainer to="/scan/firstmile/deliver">
              <button
                type="button"
                className="text-white btn btn-lg btn-janio btn-janio-redirect mb-2">
                <Trans>Deliver</Trans>
                </button>
            </LinkContainer>
            {/*<LinkContainer to="/firstmile/pickup-deliver-addresses">
              <button
                type="button"
                className="text-white btn btn-lg btn-janio btn-janio-redirect mb-2">
                See Pick Up and Deliver Addresses
                </button>
            </LinkContainer>*/}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps() {
  return {};
}

export default compose(
  connect(mapStateToProps, {}),
  withNamespaces()
)(RedirectFirstmile);
